export const applyAlimentationFilters = (annonce, filters) => {
  const {
    typeAliment = [],
    conservation = [],
    prixMin,
    prixMax,
  } = filters;

  const isTypeAlimentFiltered =
    typeAliment.length === 0 || typeAliment.includes(annonce.typeAliment);

  const isConservationFiltered =
    conservation.length === 0 || conservation.includes(annonce.conservation);

  const isPrixFiltered =
    (!prixMin || annonce.prix >= parseFloat(prixMin)) &&
    (!prixMax || annonce.prix <= parseFloat(prixMax));

  return isTypeAlimentFiltered && isConservationFiltered && isPrixFiltered;
};
